import React, { useEffect, useRef, useState } from 'react';
import { IMPACT } from '../../data/content';

function CountTo({ to, suffix }) {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    let started = false;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting && !started) {
          started = true;
          const dur = 1600;
          const start = performance.now();
          const step = (t) => {
            const p = Math.min(1, (t - start) / dur);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(Math.floor(eased * to));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      });
    }, { threshold: 0.4 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [to]);
  return <span ref={ref}>{n}{suffix}</span>;
}

export default function ImpactNumbers() {
  return (
    <section id="impact" className="relative py-24 md:py-28 border-y-2 border-white/10 bg-black/40 halftone">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-teal text-center mb-10">
          — Impact in Numbers —
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {IMPACT.map((s, i) => (
            <div
              key={s.label}
              data-testid={`impact-${i}`}
              className="text-center md:text-left"
            >
              <div className="font-display font-black text-6xl md:text-7xl text-teal tracking-tighter leading-none">
                <CountTo to={s.value} suffix={s.suffix} />
              </div>
              <div className="mt-4 font-display text-lg text-white/90">{s.label}</div>
              <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40">
                {s.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
